class CutomSelector extends HTMLElement {
  constructor() {
    super()
    this.toggler = this.querySelector('.js-dropdown-toggle');
    this.menu = this.querySelector('.js-dropdown-menu');
    this.select = this.previousElementSibling.querySelector('.js-select');
    this.variants = this.closest('variant-selects');
    this.toggler.querySelector('span').textContent = this.select?.options[this.select.selectedIndex].text;
    this.block = document.querySelector('.product__price-variant-wrapper.visible-mobile');
    this.submitBlock = document.querySelector('.product__quantity-btns-wrapper');

    this.toggler.addEventListener('keydown', this.handleToggleKeyPress);
    this.toggler.addEventListener('click', () => this.toggle());
    [...this.menu.children].forEach(item => {
      item.addEventListener('keydown', this.handleItemKeyDown);
      item.addEventListener('click', () => this.setValue(item));
    });

    this.value = this.toggler.textContent;

    this.toggle = (expand = null) => {
      expand = expand === null
        ? this.menu.getAttribute('aria-expanded') !== 'true'
        : expand;

      this.menu.setAttribute('aria-expanded', expand);

      if (expand) {
        this.classList.add('active');
        this.toggler.classList.add('active');
        this.menu.children[0].focus();
        document.addEventListener('click', this.handleClickOut);
        this.dispatchEvent(new Event('opened'));
        if(this.block != null) {
          this.submitBlock.classList.add('is-hidden');
        }
      } else {
        this.classList.remove('active');
        this.toggler.classList.remove('active');
        this.dispatchEvent(new Event('closed'));
        document.removeEventListener('click', this.handleClickOut);
        if(this.block != null) {
          this.submitBlock.classList.remove('is-hidden');
        }
      }
    }
  }

  handleClickOut = e => {
    if (!this) {
      return document.removeEventListener('click', handleClickOut);
    }

    if (!this.contains(e.target)) {
      this.toggle(false);
    }
  };

  setValue = (item) => {
    const val = item.textContent;
    this.toggler.querySelector('span').textContent = val;
    this.value = item.getAttribute('value');
    this.toggle(false);
    this.dispatchEvent(new Event('change'));
    this.toggler.focus();
    this.select.value = item.getAttribute('value');;
    this.variants.dispatchEvent(new Event('change'));
  }

  handleItemKeyDown = (e) => {
    e.preventDefault();
    if (e.keyCode === 38 && e.target.previousElementSibling) { // up
      e.target.previousElementSibling.focus();
    } else if (e.keyCode === 40 && e.target.nextElementSibling) { // down
      e.target.nextElementSibling.focus();
    } else if (e.keyCode === 27) { // escape key
      this.toggle(false);
    } else if (e.keyCode === 13 || e.keyCode === 32) { // enter or spacebar key
      this.setValue(e.target);
    }
  }

  handleToggleKeyPress = (e) => {
    if (e.keyCode !== 9) {
      e.preventDefault();
      if (e.keyCode === 27) { // escape key
        this.toggle(false);
      } else if (e.keyCode === 13 || e.keyCode === 32) { // enter or spacebar key
        this.toggle(true);
      }
    }
  }

}

customElements.define('custom-selector', CutomSelector)
